import { render } from "./CreateOrderStatusModal.vue?vue&type=template&id=01efdc75"
import script from "./CreateOrderStatusModal.vue?vue&type=script&lang=js"
export * from "./CreateOrderStatusModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__